import React from 'react'
import PropTypes from 'prop-types'

import { IconRefresh, LinkPrimary, constants } from 'mage-deps/@klarna/bubble-ui'

import NotificationBanner from './NotificationBanner'

const RedirectBanner = ({ href, ...props }) => (
  <LinkPrimary white href={href}>
    <NotificationBanner
      Icon={<IconRefresh color='white' />}
      backgroundColor={constants.Colors.BRAND_COLOR_102}
      textColor={constants.Colors.White}
      {...props}
    />
  </LinkPrimary>
)

RedirectBanner.propTypes = {
  href: PropTypes.string.isRequired
}

export default RedirectBanner
